import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchListReportDataInCurrentList() {
  const modalData = yield select(selectors.selectCurrentModalData);
  const listId = modalData?.listId;

  if (!listId) {
    return;
  }

  yield put(actions.fetchListReportData(listId));

  let item;
  try {
    ({ item } = yield call(request, api.getListReportData, listId));
  } catch (error) {
    yield put(actions.fetchListReportData.failure(listId, error));
    return;
  }

  yield put(actions.fetchListReportData.success(listId, item || null));
}

export function* upsertListReportDataInCurrentList(data) {
  const modalData = yield select(selectors.selectCurrentModalData);
  const listId = data.listId || modalData?.listId;

  if (!listId) {
    return;
  }

  // Убираем listId из data перед отправкой на сервер
  const { listId: _, ...requestData } = data;

  yield put(actions.upsertListReportData(listId, requestData));

  let item;
  try {
    ({ item } = yield call(request, api.upsertListReportData, listId, requestData));
  } catch (error) {
    yield put(actions.upsertListReportData.failure(listId, error));
    return;
  }

  yield put(actions.upsertListReportData.success(item));
}

export function* upsertListReportDataByListId(listId, data) {
  if (!listId) {
    return;
  }

  const requestData = data || {};

  yield put(actions.upsertListReportData(listId, requestData));

  let item;
  try {
    ({ item } = yield call(request, api.upsertListReportData, listId, requestData));
  } catch (error) {
    yield put(actions.upsertListReportData.failure(listId, error));
    return;
  }

  yield put(actions.upsertListReportData.success(item));
}

export function* completeListReportDataInCurrentList() {
  const modalData = yield select(selectors.selectCurrentModalData);
  const listId = modalData?.listId;

  if (!listId) {
    return;
  }

  yield put(actions.completeListReportData(listId));

  let item;
  try {
    ({ item } = yield call(request, api.completeListReportData, listId));
  } catch (error) {
    yield put(actions.completeListReportData.failure(listId, error));
    return;
  }

  yield put(actions.completeListReportData.success(item));
}

export function* completeListReportDataByListId(listId) {
  console.log('[completeListReportDataByListId] Starting for listId:', listId);
  if (!listId) {
    console.log('[completeListReportDataByListId] No listId provided');
    return;
  }

  yield put(actions.completeListReportData(listId));

  let item;
  try {
    ({ item } = yield call(request, api.completeListReportData, listId));
    console.log('[completeListReportDataByListId] Success, item:', item);
  } catch (error) {
    console.error('[completeListReportDataByListId] Error:', error);
    yield put(actions.completeListReportData.failure(listId, error));
    return;
  }

  yield put(actions.completeListReportData.success(item));
  console.log('[completeListReportDataByListId] Success action dispatched');
}

export default {
  fetchListReportDataInCurrentList,
  upsertListReportDataInCurrentList,
  upsertListReportDataByListId,
  completeListReportDataInCurrentList,
  completeListReportDataByListId,
};
